import { createContext } from 'react';

import {
  SavingsType,
  SavingsTypesDocument,
} from '@totem/components/administration/optimize/savingsTypes/types';

interface Context {
  loading: boolean;
  saving: boolean;
  document: SavingsTypesDocument | null;
  // Saves the whole list; resolves true when it was stored.
  onSave: (data: SavingsType[]) => Promise<boolean>;
  onRefresh: () => void;
  onAdd: () => void;
  onEdit: (index: number) => void;
}

export default createContext<Context>({
  loading: true,
  saving: false,
  document: null,
  onSave: () => Promise.resolve(false),
  onRefresh: () => {},
  onAdd: () => {},
  onEdit: () => {},
});
